import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import Loadingcontainer from '../loadingcontainer';
import Drilldownplaceholder from '../drilldownplaceholder';
import { dateFilter } from '../../utils/services';
import { updateComponentState } from '../../actions/actions';
import {LocalSelect} from '../utils/utilcomponents';


class EquipmentProfileByHospitalDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tabClasses: ["show active", ""],
			contractcoveragestatus : 'Under Service Provider',
			result : [],
			menumber : null,
			loaderflag : true
		};
		this.onload = this.onload.bind(this);
		this.getTabClass = this.getTabClass.bind(this);
		this.getTabPaneClass = this.getTabPaneClass.bind(this);
		this.setActiveTab = this.setActiveTab.bind(this);
		this.listbodyRef = this.listbodyRef.bind(this);
		this.renderTableHeaderRow = this.renderTableHeaderRow.bind(this);
	}

	componentWillMount() {
		this.onload();
		this.setActiveTab(1);
	}

	onload(reload){
		/*if(!reload && this.props.componentdata){
			this.setState({
				...this.props.componentdata
			});
		}else{*/
			this.setState({loaderflag:true});
			let filterstring = `&contractcoveragestatus=${this.state.contractcoveragestatus}`;

			if(this.state.menumber)
				filterstring += `&menumber=${this.state.menumber}`;

			axios.get(`/api/equipmentprofilestatus?pagetype=hospitaldetails&partnerid=${this.props.match.params.id}${filterstring}`).then((response) => {
				if (response.data.message == 'success') {
					
					let result=[];
					if(response.data.main && response.data.main.length > 0){
						result = response.data.main;
					}
					this.setState({
						result,loaderflag : false
					});
					this.props.updateComponentState(this.props.form,{
						result,loaderflag : false,contractcoveragestatus:this.state.contractcoveragestatus,menumber:this.state.menumber
					});
				} else {
					console.log(response);
				}
			});
		//}
	}


	getTabClass(tabNum) {
		return this.state.tabClasses[tabNum];
	}

	getTabPaneClass(tabNum) {
		return this.state.tabClasses[tabNum];
	}

	setActiveTab(tabNum) {
		let { tabClasses } = this.state;
		tabClasses =  ["", ""]
		tabClasses[tabNum] = "show active";
		this.setState({tabClasses});
		setTimeout(()=>{
			this.updateWindowSize();
		}, 0);
	}

	renderTableHeaderRow() {
		return (
			<thead>
				<tr>
					<th className="text-center table-header">ME Number</th>
					<th className="text-center table-header">ME Name</th>
					<th className="text-center table-header">Manufacturer</th>
					<th className="text-center table-header">Model</th>
					<th className="text-center table-header">Serial No</th>
					<th className="text-center table-header">Department</th>
					<th className="text-center table-header">Functional status</th>
					<th className="text-center table-header">Cost</th>
					<th className="text-center table-header">Registration Form</th>
					{
						(['Under Service Provider','Out of Warranty/AMC'].includes(this.state.contractcoveragestatus)) ? <th className="text-center table-header">Purchase Date</th>
						:  null
					}
					{
						(this.state.contractcoveragestatus == 'Under Warranty/AMC') ? <th className="text-center table-header">Warranty Start Date</th>
						:  null
					}
					{
						(this.state.contractcoveragestatus == 'Under Warranty/AMC') ? <th className="text-center table-header">Warranty Expiry Date</th>
						:  null
					} 
				</tr>
			</thead>
		);
	}

	listbodyRef(node) {
		if(node) {
			node.addEventListener('scroll', (evt) => {
				this.refs.listheader.scrollLeft = evt.srcElement.scrollLeft;
			});
		}
	}

	componentDidMount () {
		setTimeout(() => {
			let table_header_width = document.getElementsByClassName('trimed-table_body') ? document.getElementsByClassName('trimed-table_body')[0].clientWidth : 0;
			this.setState({ table_header_width });
		}, 300);
		window.addEventListener('resize', this.updateWindowSize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowSize);
	}

	updateWindowSize = () => {
		this.setState((prevState) => {
			return {
				duplicatereload: !prevState.duplicatereload
			}
		});
	}

	render() {
		/*if(!this.state.result || this.state.result.length == 0)
			return <Drilldownplaceholder reportdata={this.state.result}></Drilldownplaceholder>;*/
		
		let { result,loaderflag } = this.state;

		let table_body_height = $(window).outerHeight() - $('.header').outerHeight() -$('.page_title').outerHeight() - $('.page_filter').outerHeight() - $('.gs-custom-tab').outerHeight() - 60;

		let isTableHasScrollbar = $('.trimed_table_container').outerHeight() < $('.trimed-table_body').outerHeight() ? true : false;

		let tablebody_scrollWidth = $('.table_body_wrapper').outerWidth() - $('.trimed-table_body').outerWidth();

		return (
			<div className="row">
				<div className="col-lg-12 col-md-12">
					<Loadingcontainer isloading={loaderflag}></Loadingcontainer>
					<div className="row page_title">
						<div className="col-lg-12 col-md-12" >
							<div className="d-flex flex-row justify-content-between margintop-10 marginbottom-10 card-details-header">
								<div>
									<div className="cursor-ptr" style={{color: "#FFFFFF",float: "left"}} onClick={()=>{this.props.history.push('/');}}>
										<div style={{float: "left",width: "25px",height: "25px",background: "#0EC98D",textAlign: "center",borderRadius: "2px 0px 0px 2px"}}>
											<img src="./images/home-btn-icon.svg"/>
										</div>
										<div style={{float: "left",width: "50px",height: "25px",background: "#11E4A1",borderRadius: "0px 2px 2px 0px",fontFamily: "Poppins",fontStyle: "normal",fontWeight: "600",fontSize: "13px",padding: "4px"}}>
											Home
										</div>
									</div>

									<div className="cursor-ptr" style={{color: "#FFFFFF",float: "left",marginLeft:"5px"}} onClick={()=>{this.props.history.goBack();}}>
										<div style={{float: "left",width: "25px",height: "25px",background: "#6881FF",textAlign: "center",borderRadius: "2px 0px 0px 2px"}}>
											<img src="./images/back-btn-icon.svg"/>
										</div>
										<div style={{float: "left",width: "50px",height: "25px",background: "#8599FF",borderRadius: "0px 2px 2px 0px",fontFamily: "Poppins",fontStyle: "normal",fontWeight: "600",fontSize: "13px",padding: "4px"}}>
											Back
										</div>
									</div>
								</div>
								<div className=" drilldown-header" style={{textAlign:"center",float:"left",fontFamily: "Poppins",fontStyle: "normal",fontSize:"20px"}}>
										Equipment Profile and Status
								</div>
								<div></div>
							</div>
						</div>
					</div>
					<div className="row page_filter">
						<div className="form-group col-lg-2 col-md-3">
							<LocalSelect placeholder={'Select Contract Type'} className={`${(!this.state.contractcoveragestatus) ? 'errorinput' : ''}`} name={'contractcoveragestatus'} options={['Under Service Provider','Under Warranty/AMC','Out of Warranty/AMC']} value={this.state.contractcoveragestatus} multiselect={false} required={true} onChange={(value)=>{this.setState({contractcoveragestatus:value,result:[]})}}/>
						</div>
						<div className="form-group col-lg-2 col-md-3">
							<input key={'menumber'} type="text" className={`form-control`}  value={this.state.menumber} placeholder={'ME Number'} onChange={(event)=>{this.setState({menumber:event.target.value})}} required={false} autoComplete="off" ></input>
						</div>
						<div className="form-group col-lg-1 col-md-2">
							<button type="button" className="btn btn-sm btn-primary" onClick={()=>{this.onload(true);}}>Go</button>
						</div>
					</div>
					<div className="row no-gutters">
						{
							(result && result.length > 0) ?
								<div className="col-lg-12 col-md-12" style={{backgroundColor: '#fff'}}>
									<ul className="nav nav-tabs gs-custom-tab">
										<li style={{width:'25px'}}></li>
										<li className="nav-item">
											<a className={`nav-link ${this.getTabClass(1)}`} href="javascript:void(0);" onClick={()=>this.setActiveTab(1)}>Data</a>
										</li>
									</ul>
									<div className="tab-content">
										<div className={`tab-pane fade ${this.getTabPaneClass(1)}`} role="tabpanel">
											<div className="row no-gutters" style={{padding: '20px'}}>
												<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 trimed_table_container">
													<div className="trimed-table-wrapper" ref="listheader" style={{width: `${isTableHasScrollbar && tablebody_scrollWidth > 1 ? `calc(100% - ${tablebody_scrollWidth}px)` : '100%'}`}}>
														<table className="table table-bordered trimed-table">
															<colgroup>
																<col style={{width: '15%'}} />
																<col style={{width: '18%'}} />
																<col style={{width: '10%'}} />
																<col style={{width: '10%'}} />
																<col style={{width: '10%'}} />
																<col style={{width: '10%'}} />
																<col style={{width: '15%'}} />
																<col style={{width: '6%'}} />
																<col style={{width: '8%'}} />
																{
																	(['Under Service Provider','Out of Warranty/AMC'].includes(this.state.contractcoveragestatus)) ? <col style={{width: '10%'}} />
																	:  null
																}
																{
																	(this.state.contractcoveragestatus == 'Under Warranty/AMC') ? <col style={{width: '10%'}} />
																	:  null
																}
																{
																	(this.state.contractcoveragestatus == 'Under Warranty/AMC') ? <col style={{width: '10%'}} />
																	:  null
																}
															</colgroup>
															{this.renderTableHeaderRow()}
														</table>
													</div>
													<div className="table_body_wrapper" ref={this.listbodyRef} style={{width: '100%', position: 'relative', height: `${table_body_height}px`, maxHeight: `${table_body_height}px`, overflow: 'auto'}}>
														<table className="table table-hover table-bordered trimed-table trimed-table_body">
															<colgroup>
																<col style={{width: '15%'}} />
																<col style={{width: '18%'}} />
																<col style={{width: '10%'}} />
																<col style={{width: '10%'}} />
																<col style={{width: '10%'}} />
																<col style={{width: '10%'}} />
																<col style={{width: '15%'}} />
																<col style={{width: '6%'}} />
																<col style={{width: '8%'}} />
																{
																	(['Under Service Provider','Out of Warranty/AMC'].includes(this.state.contractcoveragestatus)) ? <col style={{width: '10%'}} />
																	:  null
																}
																{
																	(this.state.contractcoveragestatus == 'Under Warranty/AMC') ? <col style={{width: '10%'}} />
																	:  null
																}
																{
																	(this.state.contractcoveragestatus == 'Under Warranty/AMC') ? <col style={{width: '10%'}} />
																	:  null
																}
															</colgroup>
															{this.renderTableHeaderRow()}
															<tbody>
																{result.map((item, key) => {
																	return <tr key={key}>
																		<td className="text-center table-content">{item.menumber}</td>
																		<td className="text-center table-content">{item.mename}</td>
																		<td className="text-center table-content">{item.manufacturer}</td>
																		<td className="text-center table-content">{item.modelno}</td>
																		<td className="text-center table-content">{item.serialno}</td>
																		<td className="text-center table-content">{item.department}</td>
																		<td className="text-center table-content">{item.functionalstatus}</td>
																		<td className="text-center table-content">{item.cost}</td>
																		<td className="text-center table-content">
																			{
																				(item.registrationform) ? <a role="button" class="btn btn-default" style={{color: "#444",background: "#D3D3D3"}} href={item.registrationform} data-toggle="tooltip" title={item.registrationformname} target="_blank"><span className="fa fa-paperclip"></span></a> : null
																			}
																		</td>
																		{
																			(['Under Service Provider','Out of Warranty/AMC'].includes(this.state.contractcoveragestatus)) ? <td className="text-center table-content">{dateFilter(item.purchasedate)}</td> : null
																		}
																		{
																			(this.state.contractcoveragestatus == 'Under Warranty/AMC') ? <td className="text-center table-content">{dateFilter(item.contractstartdate)}</td> : null
																		}
																		{
																			(this.state.contractcoveragestatus == 'Under Warranty/AMC') ? <td className="text-center table-content">{dateFilter(item.contractenddate)}</td> : null
																		}
																	</tr>
																})}
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> 
							: <div className="col-lg-12 col-md-12" style={{backgroundColor: '#fff'}}><div style={{width: '100%', position: 'relative', height: `${table_body_height}px`, maxHeight: `${table_body_height}px`, overflow: 'auto'}}><Drilldownplaceholder reportdata={result}></Drilldownplaceholder></div></div>
						}
						
					</div>
				</div>
			</div>
		);
	}
}

EquipmentProfileByHospitalDetails = connect(
	(state, props) => {
		let formName = `equipmentprofilebyhospitaldetails_${props.match.params.id}`;

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateComponentState }
)(reduxForm()(EquipmentProfileByHospitalDetails));

export default EquipmentProfileByHospitalDetails;


// WEBPACK FOOTER //
// ./public/react/components/drilldowns/equipmentprofilebyhospitaldetails.js